import ArticleIcon from '@mui/icons-material/Article';
import BadgeIcon from '@mui/icons-material/Badge';
import BusinessIcon from '@mui/icons-material/Business';
import DescriptionIcon from '@mui/icons-material/Description';
import DraftsIcon from '@mui/icons-material/Drafts';
import FolderIcon from '@mui/icons-material/Folder';
import GroupIcon from '@mui/icons-material/Group';
import ListAltIcon from '@mui/icons-material/ListAlt';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import { INavItem } from 'utils/globalTypes';

export const navigationBarItems = [
  {
    name: 'Admin',
    url: '/admin/offerings',
    approved: true,
    management: true
  },
  {
    name: 'My Portfolio',
    url: '/portfolio/dashboard',
    approved: true,
    management: false,
    system: false
  },
  {
    name: 'Marketplace',
    url: '/marketplace',
    otherUrls: ['/offering']
  },
  {
    name: 'Sponsors',
    url: 'https://www.usremsecurities.com/lp-gp/',
    newTab: true,
    approved: false,
    narrow: true,
    transparent: true
  }
] as INavItem[];

export const burgerMenuItems = [
  {
    name: 'Home',
    url: '/',
    approved: false
  },
  {
    name: 'My Portfolio',
    url: '/portfolio',
    approved: true,
    management: false,
    system: false,
    menuItems: [
      {
        name: 'Dashboard',
        url: '/portfolio/dashboard'
      },
      {
        name: 'Watchlist',
        url: '/portfolio/watchlist'
      },
      {
        name: 'Buy Orders',
        url: '/portfolio/buys'
      },
      {
        name: 'Sell Orders',
        url: '/portfolio/sells'
      },
      {
        name: 'Transactions',
        url: '/portfolio/transactions'
      },
      {
        name: 'Distributions',
        url: '/portfolio/distributions'
      }
    ]
  },
  {
    name: 'Admin',
    url: '/admin',
    approved: true,
    management: true,
    menuItems: [
      {
        name: 'Users',
        url: '/admin/users?creator_id=&user_status=0'
      },
      {
        name: 'Orders',
        url: '/admin/orders?creator_id='
      },
      {
        name: 'Offerings',
        url: '/admin/offerings'
      },
      {
        name: 'Sponsors',
        url: '/admin/sponsors'
      },
      {
        name: 'Holdings',
        url: '/admin/holdings?creator_id='
      },
      {
        name: 'Transactions',
        url: '/admin/transactions?creator_id='
      },
      {
        name: 'Trades',
        url: '/admin/trades?creator_id='
      },
      {
        name: 'Documents',
        url: '/admin/documents?creator_id='
      },
      {
        name: 'Emails',
        url: '/admin/email/manage'
      },
      {
        name: 'Reports',
        url: '/admin/reports'
      }
    ]
  },
  {
    name: 'Marketplace',
    url: '/marketplace',
    otherUrls: ['/offering']
  },
  {
    name: 'About',
    url: 'https://www.usremsecurities.com/#about',
    newTab: true,
    approved: false
  },
  {
    name: 'Sponsors',
    url: 'https://www.usremsecurities.com/#sponsors',
    approved: false,
    newTab: true
  },
  {
    name: 'My Account',
    url: '/profile',
    approved: true,
    menuItems: [
      {
        name: 'Personal Details',
        url: '/profile/personal'
      },
      {
        name: 'Financial Details',
        url: '/profile/financial',
        management: false,
        system: false
      },
      {
        name: 'Entity Details',
        url: '/profile/entity',
        management: false,
        system: false
      }
    ]
  },
  {
    name: 'Update my details',
    url: '/connect/welcome',
    approved: false,
    auth: true
  },
  {
    name: 'Sign Up',
    url: 'open_sign_up',
    auth: false,
    className: 'btn_blue'
  },
  {
    name: 'Log In',
    url: 'open_sign_in',
    auth: false,
    className: 'btn_white'
  },
  {
    name: 'Sign Out',
    url: 'signOut',
    auth: true,
    className: 'btn_white'
  }
] as INavItem[];

export const sideBarItems = [
  {
    url: '/portfolio/dashboard',
    name: 'My Portfolio',
    menuItems: [
      {
        name: 'Dashboard',
        url: '/portfolio/dashboard'
      },
      {
        name: 'Watchlist',
        url: '/portfolio/watchlist'
      },
      {
        name: 'Sell Orders',
        url: '/portfolio/sells'
      },
      {
        name: 'Buy Orders',
        url: '/portfolio/buys'
      },
      {
        name: 'Transactions',
        url: '/portfolio/transactions'
      },
      {
        name: 'Distributions',
        url: '/portfolio/distributions'
      }
    ]
  },
  {
    url: '/admin/offerings',
    name: 'Sponsor',
    menuItems: [
      {
        name: 'Users',
        url: '/admin/users?creator_id=&user_status=0',
        basePath: '/admin/users',
        JsxIcon: GroupIcon,
        management: true
      },
      {
        name: 'Orders',
        url: '/admin/orders?creator_id=',
        basePath: '/admin/orders',
        JsxIcon: ListAltIcon,
        management: true
      },
      {
        name: 'Offerings',
        url: '/admin/offerings',
        basePath: '/admin/offerings',
        JsxIcon: BusinessIcon,
        management: true
      },
      {
        name: 'Sponsors',
        url: '/admin/sponsors',
        JsxIcon: BadgeIcon,
        system: true
      },
      {
        name: 'Holdings',
        url: '/admin/holdings?creator_id=',
        basePath: '/admin/holdings',
        JsxIcon: FolderIcon,
        management: true
      },
      {
        name: 'Transactions',
        url: '/admin/transactions?creator_id=',
        basePath: '/admin/transactions',
        JsxIcon: ReceiptLongIcon,
        management: true
      },
      {
        name: 'Trades',
        url: '/admin/trades?creator_id=',
        JsxIcon: ArticleIcon,
        management: true
      },
      {
        name: 'Documents',
        url: '/admin/documents?creator_id=',
        JsxIcon: ArticleIcon,
        management: true
      },
      {
        name: 'Emails',
        url: '/admin/email/manage',
        basePath: '/admin/email',
        JsxIcon: DraftsIcon,
        system: true
      },
      {
        name: 'Reports',
        url: '/admin/reports',
        basePath: '/admin/reports',
        JsxIcon: DescriptionIcon,
        system: true
      }
    ]
  }
] as INavItem[];
